<template>
    <div v-if="show" class="popup-wrapper" @click.self = "close">
        <div class="popup-content">
            <div style="display: flex;">
                <h2 style="flex: 1;">Archivos seleccionados</h2>
                <button class="cancel-button" @click="close">
                    <span class="material-symbols-outlined">close</span>
                </button>
            </div>
            <div class="item" v-for="(item, index) in fileList" :key="index">
                <h4 style="flex: 1;">{{ item.archivo.name }}</h4>
                <button @click="deleteItem(index)" title="Eliminar" class="cancel-button">
                    <span class="material-symbols-outlined">delete</span>
                </button>
                <button @click="showFile(item.url)" title="Mostrar" class="show-button">
                    <span class="material-symbols-outlined">visibility</span>
                </button>
            </div>
            <div v-if="fileList.length == 0">
                <h4 style="flex: 1;">No hay archivos listados</h4>
            </div>
        </div>
        <FileViewer v-if="showFileContent"  :file_url = "currentFileUrl" @close="closeFileView"></FileViewer>
    </div>
</template>

<script>
import FileViewer from './FileViewer.vue';
export default {
    components: {
        FileViewer
    },
    name: "PopupArchivos",
    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },
        fileList: {
            type: Array,
            required: true,
            default: () => ([])
        }
    },
    data() {
        return {
            showFileContent: false,
            currentFileUrl: ''
        };
    },
    methods: {
        showFile(url) {
            this.currentFileUrl = url;
            this.showFileContent = true;
        },
        close() {
            this.$emit('hide');
        },
        closeFileView() {
            this.showFileContent = false;
            this.currentFileUrl = '';
        },
        deleteItem(index) {
            this.$emit('deleteItem', index)
        }
    }
};
</script>

<style scoped>
.popup-wrapper {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    position: fixed;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.popup-content {
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    border-radius: 8px;
    width: 80%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: auto;
}

.file-viewer-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
}


.table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.form-actions {
    display: flex;
    justify-content: flex-end;
}

.item {
    margin-top: 1%;
    margin-bottom: 1%;
    display: flex;
    border: 2px solid #2b8b4b;
    padding: 1%;
}

.cancel-button {
    font-size: 1.5rem;
    padding: 10px;
    border-radius: 15px;
    background-color: #fd4973;
    border: 2px solid transparent;
    color: white;
    margin-right: 10px;
    transition: background-color 0.3s, border-color 0.3s;
}

.cancel-button:hover {
    background-color: #e61a42;
    border-color: #e61a42;
    transition: background-color 0.3s, border-color 0.3s;
}
.show-button {
    font-size: 1.5rem;
    padding: 10px;
    border-radius: 15px;
    background-color: #2b8b4b;
    border: 2px solid transparent;
    color: white;
    margin-right: 10px;
    transition: background-color 0.3s, border-color 0.3s;
}

.show-button:hover {
    background-color: #226b3a;
    border-color: #226b3a;
    transition: background-color 0.3s, border-color 0.3s;
}

button {
    padding: 10px 20px;
    border: none;
    cursor: pointer;
    margin-left: 10px;
}

button[type="button"] {
    background-color: #DC3545;
    color: white;
}

</style>
